const words: string[] = ['fuck', 'dick', 'sucker', 'cunt'];

export default words;
